import { createFileRoute, redirect } from '@tanstack/react-router'
import { isLegacyResearchMatchAliasPath } from '~/features/football-match-detail/legacy-route-options'
import { ResearchWorkspaceLayout } from '~/features/research-workspace/components'

export const Route = createFileRoute('/$locale/research')({
  beforeLoad: ({ location, params }) => {
    if (isLegacyResearchMatchAliasPath(location.pathname))
      return
    throw redirect({ href: `/${params.locale}/teams-players`, replace: true })
  },
  component: ResearchWorkspaceLayout,
})
